import React from "react";
import {NotifyModal} from "peggirkit";
import {SetStateFn} from "@/utils/SetStateUtils";
import {FormattedMessage, useIntl} from "react-intl";
import {globalConfirmModalProps} from "@/utils/ModalUtils";

type Props = {
    show: boolean,
    setShow: SetStateFn<boolean>,
};

const SynchronizationBusyNotification = ({show, setShow}: Props) => {
    const intl = useIntl();

    return (
        <NotifyModal
            {...globalConfirmModalProps(intl)}
            show={show}
            onClose={() => setShow(false)}
            title={intl.formatMessage({id: "syncRequestFailed"})}
            type={"danger"}
            dismissButton={{text: intl.formatMessage({id: "close"})}}
        >
            <FormattedMessage id={"syncRequestFailed.description"}/>
        </NotifyModal>
    );
};

export default SynchronizationBusyNotification;